import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { AppService } from "../services/app.service";
import { FormGroup, Validators, FormBuilder, FormArray } from "@angular/forms";
import { environment } from "../../environments/environment";
import { IMyDpOptions } from "mydatepicker";
import { DatePipe } from "@angular/common";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import * as moment from "moment";
import { SupportService } from "../services/support-service";
import { FrontDeskSharedService } from "../services/front-desk-shared.service";
import { EmployeeUploadSharedService } from "../services/employee-upload-shared.service";
import { UploadEvent } from "ngx-file-drop";
import { Router } from "@angular/router";
import { log } from "util";

@Component({
  selector: "app-front-desk",
  templateUrl: "./front-desk.component.html",
})
export class FrontDeskComponent implements OnInit {
  modalRef: BsModalRef;
  allFrontdesk: any;
  selectedTechnician: any;
  frontdeskTcList: any;
  frontdeskForm: FormGroup;
  countryList: any;
  frontdeskinfosubmit = false;
  equipments: any = [{ exam: { id: null } }];
  public myDatePickerOptions: IMyDpOptions = {};
  public issuedDatePickerOptions: IMyDpOptions = {};
  public expiredDatePickerOptions: IMyDpOptions = {};
  public terminatePickerOptions: IMyDpOptions = {};
  today = new Date();
  config = {
    ignoreBackdropClick: true,
  };
  month: any;
  placeholderschlfrom: any = "";
  placeholderschlTo: any = "";
  usertype = "2";
  exams: any = [];
  validationMessage: any = {};
  techmessage: any = {};
  statedisable = false;
  zipandpin = "Zip";
  verifyemail = true;
  verifyusername = true;
  documentList: any = [];
  registerfrontdeskList: any = [];
  backendmessage: any = "";
  emailchecking = false;
  mobilechecking = false;
  equipmentFlag = false;
  files: any = [];
  uploadFinish = false;
  selectedFiles: FileList;
  generalvalidationMessage = "";
  sizeRestriction = "";
  extendsionRestriction = "";
  extendsionRestrictionMessage = "";
  i = 0;
  documentIndex = 0;
  docuerror = false;
  remainingPercentage: any;
  terminateEmpolyee: any = [];
  workingEmpolyee: any = [];
  index = 0;
  techid: any = "";
  heading: any = "";
  popuptype: any = "";
  type: any = "";
  oldMobile = "";
  oldMobileCode = "";
  selectedIndex = 0;
  frontdeskobj: any;
  oldEmail: any = "";
  oldUsername: any = "";
  @ViewChild("validationPopup") validationPopup: TemplateRef<any>;
  @ViewChild("generalvalidation") generalvalidation: TemplateRef<any>;
  @ViewChild("deletePopup") deletePopup: TemplateRef<any>;
  @ViewChild("editPopup") editPopup: TemplateRef<any>;
  @ViewChild("yesornoPopup") yesornoPopup: TemplateRef<any>;

  constructor(
    private appservice: AppService,
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private datepipe: DatePipe,
    private supportService: SupportService,
    private frontDeskSharedService: FrontDeskSharedService,
    private router: Router,
    private employeeUploadSharedService: EmployeeUploadSharedService
  ) {
    this.frontdeskForm = formBuilder.group({
      frontdeskList: formBuilder.array([this.addNewTechnician()]),
    });
    this.allFrontdesk = [];
    this.selectedTechnician = {};
    this.countryList = [];
    const date = this.today.getDate() - 1;
    const month = this.today.getMonth() + 1;
    const year = this.today.getFullYear();

    this.myDatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      showClearDateBtn: false,
      firstDayOfWeek: "su",
      editableDateField: false,
    };

    this.issuedDatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      maxYear: this.today.getFullYear(),
      disableSince: { year: year, month: month, day: date + 1 },
      showClearDateBtn: false,
      editableDateField: false,
    };

    this.expiredDatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      showClearDateBtn: false,
      editableDateField: false,
    };

    this.terminatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      showClearDateBtn: false,
      editableDateField: false,
    };
  }

  yesornoPopuptype = "";

  formValueChange = false;
  canDeactivate(): Promise<boolean> | boolean {
    if (!this.formValueChange) {
      return true;
    } else {
      this.heading = "Info";
      this.generalvalidationMessage =
        "Are you sure you want to continue? Any unsaved changes will be lost.";
      this.yesornoPopuptype = "unsaved";
      this.openModal(this.yesornoPopup);
    }
  }

  yesButtononPopup() {
    if (this.yesornoPopuptype == "unsaved") {
      this.formValueChange = false;
      this.closemodel();
      this.router.navigate([
        localStorage.getItem("testCode").toString().trim(),
        "medical-questions",
      ]);
    }
  }
  ngAfterViewInit() {
    this.frontdeskForm.valueChanges.subscribe((val) => {
      this.formValueChange = true;
    });
  }

  closemodel() {
    this.modalRef.hide();
  }
  getMonthStr(value): string {
    return this.frontDeskSharedService.getMonthStr(value);
  }

  getMonthNumber(value) {
    return this.frontDeskSharedService.getMonthNumber(value);
  }

  addNewTechnician() {
    return this.formBuilder.group({
      firstName: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      initial: [""],
      address1: [""],
      address2: [""],
      city: [""],
      state: ["default"],
      zipcode: [""],
      country: ["default"],
      techdialcode: ["default"],
      techMobile: [
        { value: "", disabled: false },
        [
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      techdialphn: ["default"],
      techtelphn: [
        { value: "", disabled: false },
        [
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      email: [
        "",
        [Validators.required, Validators.pattern(environment.emailPattern)],
      ],
      personalemail: [
        "",
        [Validators.pattern(environment.emailPattern)],
      ],
      emergencyContactName: [""],
      emergencyContactDialcode: ["default"],
      emergencyContactNum: [
        { value: "", disabled: false },
        [
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      dateHired: [{ date: null }, [Validators.required]],
      terminatedDate: [null],
      documentList: this.formBuilder.array([]),
      //  documentoriginalname: ['', [Validators.required]],
      // uploaddoc: ['', [Validators.required]],
      technicianMobile: ["0000000000"],
      technicianPhone: ["0000000000"],
      emergencyPhone: ["0000000000"],
      stateList: [],
      emailvalid: [{ value: false }],
      emailchecking: [{ value: false }],
      frontdeskId: [""],
      userName: [""],
      usernamevalid: [{ value: false }],
      areaName: [""],
      disabled: [{ value: false }],
      ziplength: [0],
      ziperror: [false],
      zipmask: [""],
      ziplable: [""],
    });
  }

  addNewDocument() {
    return this.formBuilder.group({
      id: [""],
      documentoriginalname: ["choose file"],
      uploaddoc: ["", [Validators.required]],
    });
  }

  expiredMethod(index, event) {}

  checkMonthValidation(frommonthstr, tomonthstr): boolean {
    return this.frontDeskSharedService.checkMonthValidation(this, frommonthstr, tomonthstr);
  }

  checkYearValidation(schoolfromyear, schooltoyear): boolean {
    let flag = false;
    if (schooltoyear < this.today.getFullYear() + 1) {
      if (schoolfromyear < schooltoyear) {
        flag = true;
      } else if (schoolfromyear == schooltoyear) {
        flag = false;
      } else {
        this.validationMessage.schoolfrom =
          "From year should not greater then To year";
        this.validationMessage.schoolto = "";
        flag = false;
      }
    } else {
      this.validationMessage.schoolto = "Year should not be futrue";
      this.validationMessage.schoolfrom = "";
      flag = false;
    }
    return flag;
  }

  removeUploadeddoc(index, docindex) {
    this.frontdeskForm.controls.frontdeskList["controls"][index]["controls"][
      "documentList"
    ]["controls"].splice(docindex, 1);
    this.documentIndex += -1;
  }

  ngOnInit() {
    this.usertype = sessionStorage.getItem("usertype");
    this.getLanguage();
    this.getcountry();
    //this.getallExams(0);
    this.getAllFrontDeskByTestCenter();
    if (localStorage.getItem("countryId") != null) {
      this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
        "country"
      ].setValue(localStorage.getItem("countryId"));
      this.getStateList(0, localStorage.getItem("countryId"));
      this.changeCountry(0, localStorage.getItem("countryId"));
    }

    if (localStorage.getItem("testCenterName") != null) {
      this.supportService.testCenterName.next(
        localStorage.getItem("testCenterName")
      );
    }

    if (localStorage.getItem("stateName") != null) {
      this.supportService.stateName.next(localStorage.getItem("stateName"));
    }
  }

  addTechnician() {
    const technicianArray = <FormArray>(
      this.frontdeskForm.controls["frontdeskList"]
    );
    technicianArray.push(this.addNewTechnician());
    const index = this.frontdeskForm.controls.frontdeskList["controls"].length;
    if (this.exams && this.exams.length > 0) {
      for (let e = 0; e < this.exams.length; e++) {
        this.frontdeskForm.controls.frontdeskList["controls"][index - 1][
          "controls"
        ]["equipments"]["controls"].push(
          this.formBuilder.group({
            checked: [true, Validators.required],
            active: [this.exams[e].active, Validators.required],
            exam: [this.exams[e].exam, Validators.required],
            id: [this.exams[e].id, Validators.required],
            examshortname: [this.exams[e].examshortname, Validators.required],
            deleted: [this.exams[e].deleted, Validators.required],
          })
        );
      }
    }
    this.frontdeskinfosubmit = false;
  }

  removeTechnician(index) {
    const technicianArray = <FormArray>(
      this.frontdeskForm.controls["frontdeskList"]
    );
    if (technicianArray.length > 1) {
      technicianArray.removeAt(index);
    }
  }

  getallExams(i) {
    this.appservice.getAllExams().subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] == 200) {
          this.exams = [];
          if (res["entity"] && res["entity"].length > 0) {
            for (let index = 0; index < res["entity"].length; index++) {
              if (
                res["entity"][index]["active"] === true ||
                res["entity"][index]["active"] === "true"
              ) {
                this.exams.push(res["entity"][index]);
                this.frontdeskForm.controls.frontdeskList["controls"][i][
                  "controls"
                ]["equipments"]["controls"].push(
                  this.formBuilder.group({
                    checked: [true, Validators.required],
                    active: [
                      res["entity"][index]["active"],
                      Validators.required,
                    ],
                    exam: [res["entity"][index]["exam"], Validators.required],
                    id: [res["entity"][index]["id"], Validators.required],
                    examshortname: [
                      res["entity"][index]["examshortname"],
                      Validators.required,
                    ],
                    deleted: [
                      res["entity"][index]["deleted"],
                      Validators.required,
                    ],
                  })
                );
              }
            }
          }
          for (let index = 0; index < res["entity"].length; index++) {
            if (
              res["entity"][index]["active"] === true ||
              res["entity"][index]["active"] == "true"
            ) {
              res["entity"][index].checked = false;
              this.exams.push(res["entity"][index]);
            }
          }
          this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
            "equipments"
          ].value = Object.assign([], this.exams);
        } else {
          this.exams = [];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  dateHiredMethod(index, event) {
    this.terminatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      minYear: +event.date.year,
      disableUntil: {
        year: +event.date.year,
        month: +event.date.month,
        day: +event.date.day,
      },
      showClearDateBtn: false,
    };
    this.frontdeskForm.controls.frontdeskList["controls"][index]["controls"][
      "terminatedDate"
    ].setValue(null);
  }

  dateTerminateMethod(index, date) {}
  submitTechinfo() {
    for (
      let index = 0;
      index < this.frontdeskForm.controls.frontdeskList["controls"].length;
      index++
    ) {
      if (
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["country"].value == 231 ||
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["country"].value == "231"
      ) {
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["areaName"].setValue(
          this.frontdeskForm.controls.frontdeskList["controls"][index][
            "controls"
          ]["city"]["value"]
        );
      }
      if (
        index + 1 ==
        this.frontdeskForm.controls.frontdeskList["controls"].length
      ) {
        document.getElementById("triggerform").click();
      }
    }
  }

  getLanguage() {
    return this.frontDeskSharedService.getLanguage(this);
  }

  changeCountry(index, countryId) {
    if (countryId && countryId > 0) {
      this.frontdeskForm.controls.frontdeskList["controls"][index]["controls"][
        "state"
      ].setValue("default");
      this.getStateList(index, countryId);
      this.frontdeskForm.controls.frontdeskList["controls"][index]["controls"][
        "zipcode"
      ].setValue("");

      if (countryId == "101" || countryId == 101) {
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["ziplength"].setValue(6);
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["ziplable"].setValue("Pin code");
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["zipmask"].setValue("000000");
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["ziperror"].setValue(false);
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["areaName"].setValue("");
        
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["techdialcode"].setValue("+91");
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["technicianMobile"].setValue(environment.indiaPhoneMask);

        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["techdialphn"].setValue("+91");
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["technicianPhone"].setValue(environment.indiaPhoneMask);

        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["emergencyContactDialcode"].setValue("+91");
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["emergencyPhone"].setValue(environment.indiaPhoneMask);
      } else if (countryId == "231" || countryId == 231) {
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["ziplength"].setValue(5);
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["zipmask"].setValue("00000");
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["ziplable"].setValue("Zip code");
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["ziperror"].setValue(false);
       
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["techdialcode"].setValue("+1");
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["technicianMobile"].setValue(environment.usPhoneMask);

        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["techdialphn"].setValue("+1");
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["technicianPhone"].setValue(environment.usPhoneMask);

        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["emergencyContactDialcode"].setValue("+1");
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["emergencyPhone"].setValue(environment.usPhoneMask);
      }
    }
  }

  checkziplength(event, index) {
    if (
      event &&
      event.length !=
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["ziplength"]["value"]
    ) {
      this.frontdeskForm.controls.frontdeskList["controls"][index]["controls"][
        "ziperror"
      ].setValue(true);
    } else {
      this.frontdeskForm.controls.frontdeskList["controls"][index]["controls"][
        "ziperror"
      ].setValue(false);
    }
  }

  changeCountrycode(index, countryid, type) {
    if (type == "techdialcode") {
      if (countryid == "+91" || countryid == +91) {
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["technicianMobile"].setValue(environment.indiaPhoneMask);
      } else if (countryid == "+1" || countryid == +1) {
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["technicianMobile"].setValue(environment.usPhoneMask);
      }
    } else if (type == "techdialphn") {
      if (countryid == "+91" || countryid == +91) {
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["technicianPhone"].setValue(environment.indiaPhoneMask);
      } else if (countryid == "+1" || countryid == +1) {
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["technicianPhone"].setValue(environment.usPhoneMask);
      }
    } else if (type == "emergencyContactDialcode") {
      if (countryid == "+91" || countryid == +91) {
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["emergencyPhone"].setValue(environment.indiaPhoneMask);
      } else if (countryid == "+1" || countryid == +1) {
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["emergencyPhone"].setValue(environment.usPhoneMask);
      }
    }
  }

  verifyEmail(email, index) {
    if (this.popuptype == "modify") {
      if (
        email &&
        email != null &&
        email.match(environment.emailPattern) &&
        this.oldEmail != email &&
        this.verifyemail === true
      ) {
        this.verifyemail = false;
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["emailchecking"].setValue(true);
        this.appservice.checkTechnician(email).subscribe(
          (res) => {
            if (
              res &&
              res["status"] &&
              res["status"]["status"] &&
              res["status"]["status"] == 204
            ) {
              this.frontdeskForm.controls.frontdeskList["controls"][index][
                "controls"
              ]["emailvalid"].setValue(true);
            }
            this.frontdeskForm.controls.frontdeskList["controls"][index][
              "controls"
            ]["emailchecking"].setValue(false);
            this.verifyemail = true;
          },
          (err) => {
            this.appservice.sessionOut(err);
            if (
              err &&
              err["error"] &&
              err["error"]["status"] &&
              err["error"]["status"]["status"] == 302
            ) {
              this.generalvalidationMessage = this.techmessage.alreadyexistsFd;
              this.frontdeskForm.controls.frontdeskList["controls"][index][
                "controls"
              ]["emailvalid"].setValue(false);
              this.validationMessage.primaryEmailValidationmessage =
                "Email already exists";
              this.openModal(this.generalvalidation);
            }
            this.frontdeskForm.controls.frontdeskList["controls"][index][
              "controls"
            ]["emailchecking"].setValue(false);
            this.verifyemail = true;
            return;
          }
        );
      }
      if (this.oldEmail == email) {
        this.validationMessage.primaryEmailValidationmessage = "";
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["emailchecking"].setValue(false);
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["emailvalid"].setValue(true);
      }
    } else if (this.popuptype != "modify") {
      if (
        email &&
        email != null &&
        email.match(environment.emailPattern) &&
        this.verifyemail === true
      ) {
        this.verifyemail = false;
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["emailchecking"].setValue(true);
        this.appservice.checkTechnician(email).subscribe(
          (res) => {
            if (
              res &&
              res["status"] &&
              res["status"]["status"] &&
              res["status"]["status"] == 204
            ) {
              this.frontdeskForm.controls.frontdeskList["controls"][index][
                "controls"
              ]["emailvalid"].setValue(true);
            }
            this.frontdeskForm.controls.frontdeskList["controls"][index][
              "controls"
            ]["emailchecking"].setValue(false);
            this.verifyemail = true;
          },
          (err) => {
            this.appservice.sessionOut(err);
            if (
              err &&
              err["error"] &&
              err["error"]["status"] &&
              err["error"]["status"]["status"] == 302 &&
              !this.frontdeskForm.controls.frontdeskList["controls"][index][
                "controls"
              ]["emailchecking"].value.value
            ) {
              this.generalvalidationMessage = this.techmessage.alreadyexistsFd;
              this.frontdeskForm.controls.frontdeskList["controls"][index][
                "controls"
              ]["emailvalid"].setValue(false);
              this.validationMessage.primaryEmailValidationmessage =
                "Email already exists";
              this.openModal(this.generalvalidation);
            }
            this.frontdeskForm.controls.frontdeskList["controls"][index][
              "controls"
            ]["emailchecking"].setValue(false);
            this.verifyemail = true;
            return;
          }
        );
      }
    }
  }

  private redirectToPlanSubscriptionIfNeeded() {
    if (
      this.usertype == "2" &&
      localStorage.getItem("subscriptionflag") != null &&
      localStorage.getItem("subscriptionflag") == "false"
    ) {
      setTimeout(() => {
        this.router.navigate([
          localStorage.getItem("testCode").toString().trim(),
          "plan-subscription",
        ]);
      }, 1500);
    }
  }

  checkEmailValidationMessage(value) {
    if (this.frontdeskinfosubmit === true) {
      if (value.toString().trim()) {
        const email = value.toString().trim();
        if (email.match(environment.emailPattern)) {
          this.validationMessage.primaryEmailValidationmessage = "";
        } else {
          this.validationMessage.primaryEmailValidationmessage = this.validationMessage.validEmail;
        }
      } else if (!value.toString().trim()) {
        this.validationMessage.primaryEmailValidationmessage = this.validationMessage.emailid;
      } else {
        this.validationMessage.primaryEmailValidationmessage = "";
      }
    }
  }

  checkPersonalEmailValidationMessage(value) {
    if (this.frontdeskinfosubmit === true) {
      if (value.toString().trim()) {
        const email = value.toString().trim();
        if (email.match(environment.emailPattern)) {
          this.validationMessage.primaryPersonalEmailValidationmessage = "";
        } else {
          this.validationMessage.primaryPersonalEmailValidationmessage = this.validationMessage.validEmail;
        }
      } else if (!value.toString().trim()) {
        this.validationMessage.primaryPersonalEmailValidationmessage = this.validationMessage.emailid;
      } else {
        this.validationMessage.primaryPersonalEmailValidationmessage = "";
      }
    }
  }

  yearValidation(value): number {
    return this.frontDeskSharedService.yearValidation(this, value);
  }

  monthValidation(value): number {
    return this.frontDeskSharedService.monthValidation(this, value);
  }

  dayValidation(value, totalday): number {
    return this.frontDeskSharedService.dayValidation(this, value, totalday);
  }

  checkTotalDaycount(month): number {
    return this.frontDeskSharedService.checkTotalDaycount(this, month);
  }

  registerFrontdesk(frontdeskinfo) {
    this.frontdeskinfosubmit = true;
    if (frontdeskinfo.valid && frontdeskinfo.status == "VALID") {
      this.registerfrontdeskList = [];
      for (let index = 0; index < frontdeskinfo.controls.length; index++) {
        this.documentList = [];
        // if (
        //   frontdeskinfo.controls[index]["controls"]["state"]["value"] ==
        //   "default"
        // ) {
        //   this.openModal(this.validationPopup);
        //   return;
        // }

        if (
          !frontdeskinfo.controls[index]["controls"]["dateHired"]["value"] ||
          !frontdeskinfo.controls[index]["controls"]["dateHired"]["value"][
            "date"
          ]
        ) {
          this.openModal(this.validationPopup);
          return;
        }

        if (
          this.frontdeskForm.controls.frontdeskList["controls"][index][
            "controls"
          ]["emailvalid"].value === false
        ) {
          this.openModal(this.validationPopup);
          return;
        }

        for (
          let i = 0;
          i < frontdeskinfo.controls[index]["controls"].length;
          i++
        ) {
          if (frontdeskinfo.controls[index]["controls"]["zipcode"].value &&
            frontdeskinfo.controls[index]["controls"]["zipcode"].value.length !=
            frontdeskinfo.controls[index]["controls"]["ziplength"].value
          ) {
            frontdeskinfo.controls[index]["controls"]["ziperror"].setValue(
              true
            );
            return;
          }
        }

        for (
          let ii = 0;
          ii <
          frontdeskinfo.controls[index]["controls"]["documentList"]["controls"]
            .length;
          ii++
        ) {
          if (
            frontdeskinfo.controls[index]["controls"]["documentList"][
              "controls"
            ][ii]["controls"]["documentoriginalname"]["value"] &&
            frontdeskinfo.controls[index]["controls"]["documentList"][
              "controls"
            ][ii]["controls"]["uploaddoc"]["value"] &&
            frontdeskinfo.controls[index]["controls"]["documentList"][
              "controls"
            ][ii]["controls"]["uploadValid"]["value"]
          ) {
            const documentObj = {
              documentoriginalname:
                frontdeskinfo.controls[index]["controls"]["documentList"][
                  "controls"
                ][ii]["controls"]["documentoriginalname"]["value"],
              document:
                frontdeskinfo.controls[index]["controls"]["documentList"][
                  "controls"
                ][ii]["controls"]["uploaddoc"]["value"],
            };
            this.documentList.push(documentObj);
          }
        }

        let datehired = null;
        let terminatedate = null;
        if (
          frontdeskinfo.controls[index]["controls"]["dateHired"]["value"] &&
          frontdeskinfo.controls[index]["controls"]["dateHired"]["value"].date
        ) {
          datehired =
            frontdeskinfo.controls[index]["controls"]["dateHired"]["value"].date
              .year +
            "-" +
            frontdeskinfo.controls[index]["controls"]["dateHired"]["value"].date
              .month +
            "-" +
            frontdeskinfo.controls[index]["controls"]["dateHired"]["value"].date
              .day;
        }
        if (
          frontdeskinfo.controls[index]["controls"]["terminatedDate"][
            "value"
          ] &&
          frontdeskinfo.controls[index]["controls"]["terminatedDate"]["value"]
            .date
        ) {
          terminatedate =
            frontdeskinfo.controls[index]["controls"]["terminatedDate"]["value"]
              .date.year +
            "-" +
            frontdeskinfo.controls[index]["controls"]["terminatedDate"]["value"]
              .date.month +
            "-" +
            frontdeskinfo.controls[index]["controls"]["terminatedDate"]["value"]
              .date.day;
        }

        var data = {
          frontdeskId:
            this.frontdeskobj && this.frontdeskobj.id
              ? this.frontdeskobj.id
              : "",
          testCenterId: localStorage.getItem("testCenterId"),
          firstName:
            frontdeskinfo.controls[index]["controls"]["firstName"]["value"],
          lastName:
            frontdeskinfo.controls[index]["controls"]["lastName"]["value"],
          initial: frontdeskinfo.controls[index]["controls"]["initial"]["value"]
            .toString()
            .toUpperCase(),
          userName: frontdeskinfo.controls[index]["controls"]["email"]["value"],
          address: {
            id:this.frontdeskobj && this.frontdeskobj.address && this.frontdeskobj.address.id?this.frontdeskobj.address.id:'',
            street: "",
            addressLine1:
              frontdeskinfo.controls[index]["controls"]["address1"]["value"],
            addressLine2:
              frontdeskinfo.controls[index]["controls"]["address2"]["value"],
            cityName:
              frontdeskinfo.controls[index]["controls"]["city"]["value"],
            areaName:
              frontdeskinfo.controls[index]["controls"]["areaName"]["value"],
            state: {
              id: frontdeskinfo.controls[index]["controls"]["state"]["value"] != 'default'?frontdeskinfo.controls[index]["controls"]["state"]["value"]:0,
            },

            country: {
              id: frontdeskinfo.controls[index]["controls"]["country"]["value"],
            },
            zipCode:
              frontdeskinfo.controls[index]["controls"]["zipcode"]["value"],
          },
          phoneCode:
            frontdeskinfo.controls[index]["controls"]["techdialphn"]["value"],
          phoneNumber:
            frontdeskinfo.controls[index]["controls"]["techtelphn"]["value"],
          telCode:
            frontdeskinfo.controls[index]["controls"]["techdialcode"]["value"],
          telNumber:
            frontdeskinfo.controls[index]["controls"]["techMobile"]["value"],
          email: frontdeskinfo.controls[index]["controls"]["email"]["value"],
          personalEmail:
            frontdeskinfo.controls[index]["controls"]["personalemail"]["value"],
          emergencyContactInfo: {
            firstName:
              frontdeskinfo.controls[index]["controls"]["emergencyContactName"][
                "value"
              ],
            lastName: "technician",
            phoneNumber:
              frontdeskinfo.controls[index]["controls"]["emergencyContactNum"][
                "value"
              ],
            phoneCode:
              frontdeskinfo.controls[index]["controls"][
                "emergencyContactDialcode"
              ]["value"],
          },
          document: this.documentList,
          dateHired: datehired,
          dateTerminated: terminatedate,
        };
        this.registerfrontdeskList.push(data);
      }
      if (this.frontdeskobj && this.popuptype == "modify") {
        this.appservice.updatefrontDesk(data).subscribe(
          (res) => {
            if (res && res["status"] && res["status"]["status"] == 200) {
              this.cancelModify();
              this.backendmessage = this.techmessage.updateFront;
              setTimeout(() => {
                this.backendmessage = "";
              }, 5000);
              this.getAllFrontDeskByTestCenter();
              this.redirectToPlanSubscriptionIfNeeded();
            }
          },
          (err) => {
            if (
              err &&
              err["error"] &&
              err["error"]["status"] &&
              err["error"]["status"]["status"] == 302
            ) {
              this.generalvalidationMessage = this.techmessage.alreadyexists;
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["emailvalid"].setValue(true);
              this.validationMessage.primaryEmailValidationmessage =
                "Email already exists";
              this.openModal(this.generalvalidation);
            }
            this.appservice.sessionOut(err);
          }
        );
      } else {
        const final = {
          frontDesk: this.registerfrontdeskList,
        };
        this.appservice.registerFrontDesk(final).subscribe(
          (res) => {
            if (res && res["status"] && res["status"]["status"] == 200) {
              this.backendmessage = this.techmessage.frontAddSuccess;
              setTimeout(() => {
                this.backendmessage = "";
              }, 5000);
              this.cancelModify();
              this.getAllFrontDeskByTestCenter();
              this.redirectToPlanSubscriptionIfNeeded();
            }
          },
          (err) => {
            if (
              err &&
              err["error"] &&
              err["error"]["status"] &&
              err["error"]["status"]["status"] == 302
            ) {
              this.generalvalidationMessage = this.techmessage.alreadyexistsFd;
              this.validationMessage.primaryEmailValidationmessage =
                "Email already exists";
              this.openModal(this.generalvalidation);
            }
            this.appservice.sessionOut(err);
          }
        );
      }
    } else {
      for (
        let index = 0;
        index < this.frontdeskForm.controls.frontdeskList["controls"].length;
        index++
      ) {
        if (
          this.frontdeskForm.controls.frontdeskList["controls"][index][
            "controls"
          ]["email"]["value"] &&
          this.frontdeskForm.controls.frontdeskList["controls"][index][
            "controls"
          ]["email"]["valid"] === false
        ) {
          this.checkEmailValidationMessage(
            this.frontdeskForm.controls.frontdeskList["controls"][index][
              "controls"
            ]["email"]["value"]
          );
        }
        if (
          this.frontdeskForm.controls.frontdeskList["controls"][index][
            "controls"
          ]["personalemail"]["value"] &&
          this.frontdeskForm.controls.frontdeskList["controls"][index][
            "controls"
          ]["personalemail"]["valid"] === false
        ) {
          this.checkPersonalEmailValidationMessage(
            this.frontdeskForm.controls.frontdeskList["controls"][index][
              "controls"
            ]["personalemail"]["value"]
          );
        }
        if (
          !this.frontdeskForm.controls.frontdeskList["controls"][index][
            "controls"
          ]["email"].value ||
          this.frontdeskForm.controls.frontdeskList["controls"][index][
            "controls"
          ]["email"].value == ""
        ) {
          this.frontdeskForm.controls.frontdeskList["controls"][index][
            "controls"
          ]["emailvalid"].setValue(true);
        }
      }
      this.openModal(this.validationPopup);
    }
  }

  public dropped(i, event: UploadEvent) {
    return this.employeeUploadSharedService.dropped(this, i, event);
  }

  documentUpload(index, files) {
    this.selectedFiles = files;
    const file = this.selectedFiles;
    if (file && file.length > 0) {
      if (this.i >= file.length) {
        this.i = 0;
        if (this.docuerror) {
          let sizemessage = "";
          let extnmessage = "";
          if (this.sizeRestriction && !this.extendsionRestriction) {
            sizemessage = this.sizeRestriction;
          }
          if (this.sizeRestriction && this.extendsionRestriction) {
            sizemessage = "," + this.sizeRestriction;
          }
          if (this.extendsionRestriction) {
            extnmessage = this.extendsionRestriction + "invalid file format ";
          }
          this.backendmessage = "";
          this.extendsionRestrictionMessage = extnmessage + sizemessage;
          setTimeout(() => {
            this.extendsionRestriction = "";
            this.sizeRestriction = "";
            this.extendsionRestrictionMessage = "";
          }, 5000);
        }
        return;
      }
      const checkValidFile = this.appservice.getCredential(file[this.i]);
      if (
        checkValidFile.fileExtenstion.toLowerCase() == "txt" ||
        checkValidFile.fileExtenstion.toLowerCase() == "docx" ||
        checkValidFile.fileExtenstion.toLowerCase() == "csv" ||
        checkValidFile.fileExtenstion.toLowerCase() == "wps" ||
        checkValidFile.fileExtenstion.toLowerCase() == "doc" ||
        checkValidFile.fileExtenstion.toLowerCase() == "xlsx" ||
        checkValidFile.fileExtenstion.toLowerCase() == "pdf" ||
        checkValidFile.fileExtenstion.toLowerCase() == "jpeg" ||
        checkValidFile.fileExtenstion.toLowerCase() == "jpg" ||
        checkValidFile.fileExtenstion.toLowerCase() == "png" ||
        checkValidFile.fileExtenstion.toLowerCase() == "gif" ||
        checkValidFile.fileExtenstion.toLowerCase() == "tif" ||
        checkValidFile.fileExtenstion.toLowerCase() == "xls"
      ) {
        // if (((checkValidFile.fileExtenstion.toLowerCase() == "txt") || (checkValidFile.fileExtenstion.toLowerCase()) == "docx" || (checkValidFile.fileExtenstion.toLowerCase()) == "csv" || (checkValidFile.fileExtenstion.toLowerCase()) == "zip" || (checkValidFile.fileExtenstion.toLowerCase()) == "wps" || (checkValidFile.fileExtenstion.toLowerCase()) == "doc" || (checkValidFile.fileExtenstion.toLowerCase()) == "xlsx") || (checkValidFile.fileExtenstion.toLowerCase()) == "pdf") {

        const w = file[this.i].size;
        if (w > 0 && +w <= 20000000) {
          const params = this.appservice.getParams(
            file[this.i],
            checkValidFile
          );
          this.awsUploadFile(file[this.i], params, index, this.documentIndex);

          const key = params.Key;
          this.frontdeskForm.controls.frontdeskList["controls"][index][
            "controls"
          ]["documentList"]["controls"].push(
            this.formBuilder.group({
              id: [""],
              documentoriginalname: [checkValidFile.fileName],
              uploaddoc: [key],
              uploadFinish: [true],
              uploadValid: [true],
              percentage: [0],
              errorMessage: [""],
            })
          );
        } else {
          this.docuerror = true;
          this.sizeRestriction += "File Should be below 20 MB" + " ";
          this.i += 1;
          this.documentUpload(index, this.selectedFiles);
        }
      } else {
        this.docuerror = true;
        this.extendsionRestriction += "." + checkValidFile.fileExtenstion + " ";
        this.i += 1;
        this.documentUpload(index, this.selectedFiles);
      }
    } else {
      this.i = 0;
    }
  }

  downloadDoc(key) {
    return this.frontDeskSharedService.downloadDoc(this, key);
  }

  awsUploadFile(file, params, index, i) {
    return this.employeeUploadSharedService.awsUploadFile(
      this,
      file,
      params,
      index,
      i
    );
  }

  progressBarValue(percentage, index, i) {
    this.remainingPercentage = percentage;
    this.frontdeskForm.controls.frontdeskList["controls"][index]["controls"][
      "documentList"
    ]["controls"][i]["controls"]["percentage"].setValue(
      this.remainingPercentage
    );
    if (
      this.frontdeskForm.controls.frontdeskList["controls"][index]["controls"][
        "documentList"
      ]["controls"][i]["controls"]["percentage"]["value"] == 100
    ) {
      this.i += 1;
      this.documentIndex += 1;
      this.frontdeskForm.controls.frontdeskList["controls"][index]["controls"][
        "documentList"
      ]["controls"][i]["controls"]["uploadFinish"].setValue(false);
      this.documentUpload(index, this.selectedFiles);
    }
  }
  personalEmailInput(value) {
    return this.frontDeskSharedService.personalEmailInput(this, value);
  }

  emailInput(value, index) {
    this.checkEmailValidationMessage(value);
    this.verifyEmail(value, index);
  }

  openModal(template: TemplateRef<any>) {
    return this.frontDeskSharedService.openModal(this, template);
  }

  getAllFrontDeskByTestCenter() {
    this.frontdeskobj = {};
    const data = {
      testcenterId: localStorage.getItem("testCenterId"),
      pageNumber: 0,
      pageSize: 0,
      sortColumn: "createdOn",
      sortType: "desc",
    };
    this.appservice.getAllFrontDeskByTestCenter(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] == 200) {
          this.workingEmpolyee = [];
          this.terminateEmpolyee = [];
          this.allFrontdesk = res["entity"];
          for (let index = 0; index < this.allFrontdesk.length; index++) {
            if(this.allFrontdesk[index].id !== localStorage.getItem("fc_id")){
              this.allFrontdesk[index].dateHired = this.datepipe.transform(
                this.allFrontdesk[index].dateHired
              );
              if (this.allFrontdesk[index].dateTerminated) {
                if (
                  new Date(this.allFrontdesk[index].dateTerminated).getTime() <
                  this.today.getTime()
                ) {
                  this.allFrontdesk[index].removeFlag = true;
                  this.allFrontdesk[index].fullName =
                    this.allFrontdesk[index].firstName +
                    " " +
                    this.allFrontdesk[index].lastName;
                  this.terminateEmpolyee.push(this.allFrontdesk[index]);
                } else {
                  this.allFrontdesk[index].removeFlag = false;
                  this.allFrontdesk[index].disable = false;
                  this.allFrontdesk[index].fullName =
                    this.allFrontdesk[index].firstName +
                    " " +
                    this.allFrontdesk[index].lastName;
                  this.workingEmpolyee.push(this.allFrontdesk[index]);
                }
              } else {
                this.allFrontdesk[index].removeFlag = false;
                this.allFrontdesk[index].disable = false;
                this.allFrontdesk[index].fullName =
                  this.allFrontdesk[index].firstName +
                  " " +
                  this.allFrontdesk[index].lastName;
                this.workingEmpolyee.push(this.allFrontdesk[index]);
              }
            }
          }
        }
        this.formValueChange = false;
      },
      (err) => {
        this.appservice.sessionOut(err);
        this.formValueChange = false;
      }
    );
  }

  getMobileMask(code, telNumber): string {
    return this.frontDeskSharedService.getMobileMask(this, code, telNumber);
  }
  askpopupforRemovetechnician(index, techid, type) {
    this.index = index;
    this.techid = techid;
    this.heading = "Remove";
    this.popuptype = "delete";
    this.type = type;
    this.generalvalidationMessage = "Are you sure delete the front desk?";
    this.openModal(this.deletePopup);
  }

  cancelModifyTechnician(index, techid, type) {
    this.index = index;
    this.techid = techid;
    this.heading = "Info";
    this.popuptype = "cancel";
    this.type = type;
    this.generalvalidationMessage =
      "Are you sure you want to cancel the changes?";
    this.openModal(this.deletePopup);
  }

  askPopupForModifyTechnician(id, index, type) {
    this.techid = id;
    let valid = false;
    if (this.frontdeskForm.controls.frontdeskList["controls"].length > 0) {
      for (
        let index = 0;
        index < this.frontdeskForm.controls.frontdeskList["controls"].length;
        index++
      ) {
        if (
          this.frontdeskForm.controls.frontdeskList["controls"][index].valid
        ) {
          valid = true;
        }
      }
      if (valid) {
        this.heading = "Info";
        this.popuptype = "modify";
        this.generalvalidationMessage =
          "You have a unsaved front desk, Please save or it will lost";
        this.openModal(this.editPopup);
      } else {
        this.popuptype = "modify";
        if (type == "w") {
          this.workingEmpolyee[index].disable = true;
        }
        if (type == "t") {
          this.terminateEmpolyee[index].disable = true;
        }
        this.modifyTechnician(this.techid);
      }
    } else {
      this.popuptype = "modify";
      this.modifyTechnician(this.techid);
    }
  }

  cancelModify() {
    this.popuptype = "notmodify";
    this.scrollTop("scrollme");
    this.frontdeskinfosubmit = false;
    this.frontdeskobj = {};
    this.frontdeskForm.reset();
    this.oldEmail = "";
    this.oldUsername = "";
    for (
      let index = 0;
      index < this.frontdeskForm.controls.frontdeskList["controls"].length;
      index++
    ) {
      if (this.frontdeskForm.controls.frontdeskList["controls"].length > 1) {
        this.frontdeskForm.controls.frontdeskList["controls"].splice(index, 1);
      }
    }
    // this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"]["documentoriginalname"].setValue("choose file");
    if (localStorage.getItem("countryId") != null) {
      this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
        "country"
      ].setValue(localStorage.getItem("countryId"));
      if (localStorage.getItem("countryId") == "101") {
        this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
          "techdialcode"
        ].setValue("+91");
        this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
          "techdialphn"
        ].setValue("+91");
        this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
          "emergencyContactDialcode"
        ].setValue("+91");
      }

      if (localStorage.getItem("countryId") == "231") {
        this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
          "techdialcode"
        ].setValue("+1");
        this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
          "techdialphn"
        ].setValue("+1");
        this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
          "emergencyContactDialcode"
        ].setValue("+1");
      }

      this.getStateList(0, localStorage.getItem("countryId"));
      this.changeCountry(0, localStorage.getItem("countryId"));
    } else {
      this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
        "country"
      ].setValue("default");
      this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
        "techdialcode"
      ].setValue("default");
      this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
        "techdialphn"
      ].setValue("default");
      this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
        "emergencyContactDialcode"
      ].setValue("default");
    }

    this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
      "state"
    ].setValue("default");
    this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
      "dateHired"
    ].setValue({ date: null });
    this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
      "terminatedDate"
    ].setValue({ date: null });
    this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"][
      "documentList"
    ] = this.formBuilder.array([]);
  }

  sendemailLink(index, frontdeskForm) {
    if (frontdeskForm.valid && !this.emailchecking) {
      const email = this.frontdeskForm.controls.frontdeskList["controls"][
        index
      ]["controls"]["email"].value;
      if (email && email.match(environment.emailPattern)) {
        const data = {
          email: email,
        };
        this.appservice.generateLink(data).subscribe(
          (res) => {
            if (res && res["status"] && res["status"]["status"] == 200) {
              this.backendmessage = this.techmessage.mobLinksend;
              setTimeout(() => {
                this.backendmessage = "";
              }, 5000);
            } else if (res && res["status"] && res["status"]["status"] == 229) {
              this.generalvalidationMessage = this.techmessage.giveRegTechEmail;
              this.openModal(this.generalvalidation);
            } else if (res && res["status"] && res["status"]["status"] == 238) {
              this.generalvalidationMessage = this.techmessage.unverifyTech;
              this.openModal(this.generalvalidation);
            }
          },
          (err) => {
            this.appservice.sessionOut(err);
          }
        );
      } else {
        this.generalvalidationMessage = this.techmessage.validEmail;
        this.openModal(this.generalvalidation);
      }
    } else {
      this.generalvalidationMessage = this.techmessage.addressHighlight;
      this.frontdeskinfosubmit = true;
      this.openModal(this.generalvalidation);
    }
  }

  sendLink(index, frontdeskForm, type) {
    if (frontdeskForm.valid) {
      if (
        type === "mobile" &&
        (this.oldMobile !=
          this.frontdeskForm.controls.frontdeskList["controls"][index][
            "controls"
          ]["techMobile"].value ||
          this.oldMobileCode !=
            this.frontdeskForm.controls.frontdeskList["controls"][index][
              "controls"
            ]["techdialcode"].value)
      ) {
        this.generalvalidationMessage = this.techmessage.savefront;
        this.openModal(this.generalvalidation);
        return;
      } else if (
        type == "email" &&
        this.oldEmail !=
          this.frontdeskForm.controls.frontdeskList["controls"][index][
            "controls"
          ]["email"].value
      ) {
        this.generalvalidationMessage = this.techmessage.savefront;
        this.openModal(this.generalvalidation);
        return;
      }

      if (
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["frontdeskId"] &&
        this.frontdeskForm.controls.frontdeskList["controls"][index][
          "controls"
        ]["frontdeskId"].value
      ) {
        const frontdeskId = this.frontdeskForm.controls.frontdeskList[
          "controls"
        ][index]["controls"]["frontdeskId"].value;
        this.appservice.generatelinktofrontdesk(frontdeskId, type).subscribe(
          (res) => {
            if (res && res["status"] && res["status"]["status"] == 200) {
              if (type == "email") {
                this.backendmessage = this.techmessage.checkemail;
              } else {
                this.backendmessage = this.techmessage.checkmobile;
              }
              setTimeout(() => {
                this.backendmessage = "";
              }, 5000);
            } else if (res && res["status"] && res["status"]["status"] == 229) {
              this.generalvalidationMessage = this.techmessage.giveRegFdEmail;
              this.openModal(this.generalvalidation);
            } else if (res && res["status"] && res["status"]["status"] == 227) {
              this.generalvalidationMessage = this.techmessage.terminatedFront;
              this.openModal(this.generalvalidation);
            } else if (res && res["status"] && res["status"]["status"] == 238) {
              this.generalvalidationMessage = this.techmessage.unverifyFront;
              this.openModal(this.generalvalidation);
            }
          },
          (err) => {
            this.appservice.sessionOut(err);
          }
        );
      } else {
        this.generalvalidationMessage = this.techmessage.savefront;
        this.openModal(this.generalvalidation);
      }
    } else {
      this.generalvalidationMessage = this.techmessage.addressHighlight;
      this.frontdeskinfosubmit = true;
      this.openModal(this.generalvalidation);
    }
  }

  triggerPopup() {
    if (this.popuptype == "delete") {
      this.deletefrontdesk(this.index, this.techid);
    }
    if (this.popuptype == "modify") {
      this.modifyTechnician(this.techid);
    }
    document.getElementById("closepopup").click();
  }

  scrollTop(value) {
    document.getElementById(value).scrollIntoView();
  }

  modifyTechnician(techid) {
    this.frontdeskobj = {};
    if (techid) {
      this.appservice.getFrontDeskByFrontDeskId(techid).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] == 200) {
            for (
              let index = 0;
              index <
              this.frontdeskForm.controls.frontdeskList["controls"].length;
              index++
            ) {
              if (
                this.frontdeskForm.controls.frontdeskList["controls"].length > 1
              ) {
                this.frontdeskForm.controls.frontdeskList["controls"].splice(
                  index,
                  1
                );
              }
            }
            this.scrollTop("scrollme");
            this.frontdeskobj = res["entity"];

            this.frontdeskForm.reset();
            this.oldEmail = res["entity"]["email"];
            this.oldUsername = res["entity"]["userName"];
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["firstName"].setValue(res["entity"]["firstName"]);
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["lastName"].setValue(res["entity"]["lastName"]);
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["initial"].setValue(res["entity"]["initial"]);
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["address1"].setValue(res["entity"]["address"]["addressLine1"]);
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["address2"].setValue(res["entity"]["address"]["addressLine2"]);
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["zipcode"].setValue(res["entity"]["address"]["zipCode"]);
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["areaName"].setValue(res["entity"]["address"]["areaName"]);
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["country"].setValue(res["entity"]["address"]["country"]["id"]);
            if (
              res["entity"]["address"]["country"]["id"] &&
              res["entity"]["address"]["country"]["id"] == 101
            ) {
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["ziplength"].setValue(6);
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["zipmask"].setValue("000000");
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["ziperror"].setValue(false);
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["ziplable"].setValue("Pin code");
            }
            if (
              res["entity"]["address"]["country"]["id"] &&
              res["entity"]["address"]["country"]["id"] == 231
            ) {
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["ziplength"].setValue(5);
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["zipmask"].setValue("00000");
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["ziperror"].setValue(false);
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["ziplable"].setValue("Zip code");
            }
            this.getStateList(
              0,
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["country"].value
            );
            if(res["entity"]["address"] && res["entity"]["address"]["state"] && res["entity"]["address"]["state"]["id"]){
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["state"].setValue(res["entity"]["address"]["state"]["id"]);
            }else {
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["state"].setValue("default");
            }
           
            //this.getcityList(0, this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"]["state"].value);
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["city"].setValue(res["entity"]["address"]["cityName"]);

            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["techdialphn"].setValue(res["entity"]["phoneCode"]);
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["techtelphn"].setValue(res["entity"]["phoneNumber"]);
            this.oldMobile = res["entity"]["telNumber"];
            this.oldMobileCode = res["entity"]["telCode"];
            this.changeCountrycode(
              0,
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["techdialphn"]["value"],
              "techdialphn"
            );
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["techdialcode"].setValue(res["entity"]["telCode"]);
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["techMobile"].setValue(res["entity"]["telNumber"]);
            this.changeCountrycode(
              0,
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["techdialcode"]["value"],
              "techdialcode"
            );

            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["emergencyContactName"].setValue(
              res["entity"]["emergencyContactInfo"]["firstName"]
            );
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["emergencyContactDialcode"].setValue(
              res["entity"]["emergencyContactInfo"]["phoneCode"]
            );
            this.changeCountrycode(
              0,
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["emergencyContactDialcode"]["value"],
              "emergencyContactDialcode"
            );
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["emergencyContactNum"].setValue(
              res["entity"]["emergencyContactInfo"]["phoneNumber"]
            );
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["frontdeskId"].setValue(res["entity"]["id"]);
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["usernamevalid"].setValue(true);
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["emailvalid"].setValue(true);
            const localdate = res["entity"]["dateHired"]
              ? moment.utc(res["entity"]["dateHired"]).toDate()
              : null;
            if (localdate) {
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["dateHired"].setValue({
                date: {
                  year: localdate.getFullYear(),
                  month: localdate.getMonth() + 1,
                  day: localdate.getDate(),
                },
              });
            } else {
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["dateHired"].setValue({ date: null });
            }

            const localTerminatedate = res["entity"]["dateTerminated"]
              ? moment.utc(res["entity"]["dateTerminated"]).toDate()
              : null;

            if (localTerminatedate) {
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["terminatedDate"].setValue({
                date: {
                  year: localTerminatedate.getFullYear(),
                  month: localTerminatedate.getMonth() + 1,
                  day: localTerminatedate.getDate(),
                },
              });
            } else {
              this.frontdeskForm.controls.frontdeskList["controls"][0][
                "controls"
              ]["terminatedDate"].setValue({ date: null });
            }

            // this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"]["uploaddoc"].setValue(res["entity"]["document"]["document"]);
            // this.frontdeskForm.controls.frontdeskList["controls"][0]["controls"]["documentoriginalname"].setValue(res["entity"]["document"]["documentoriginalname"]);

            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["personalemail"].setValue(res["entity"]["personalEmail"]);
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["email"].setValue(res["entity"]["email"]);
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["userName"].setValue(res["entity"]["userName"]);
            this.frontdeskForm.controls.frontdeskList["controls"][0][
              "controls"
            ]["documentList"] = this.formBuilder.array([]);
            if (
              res["entity"]["document"] &&
              res["entity"]["document"].length > 0
            ) {
              for (
                let index = 0;
                index < res["entity"]["document"].length;
                index++
              ) {
                this.frontdeskForm.controls.frontdeskList["controls"][0][
                  "controls"
                ]["documentList"]["controls"].push(
                  this.formBuilder.group({
                    id: [res["entity"]["document"][index].id],
                    documentoriginalname: [
                      res["entity"]["document"][index].documentoriginalname,
                    ],
                    uploaddoc: [res["entity"]["document"][index].document],
                    uploadFinish: [false],
                    uploadValid: [true],
                    percentage: [0],
                    errorMessage: [""],
                  })
                );
              }

              this.documentIndex += this.frontdeskForm.controls.frontdeskList[
                "controls"
              ][0]["controls"]["documentList"]["controls"].length;
            }
          }
        },
        (err) => {
          this.appservice.sessionOut(err);
        }
      );
    }
  }
  roundprocessvalue(value): number {
    return this.frontDeskSharedService.roundprocessvalue(this, value);
  }
  onActivate() {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 100); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }

  getFirstIndex(index) {
    if (
      this.frontdeskForm.controls.frontdeskList["controls"][index]["controls"][
        "lastName"
      ].value &&
      this.frontdeskForm.controls.frontdeskList["controls"][index]["controls"][
        "firstName"
      ].value
    ) {
      const lastNameletter = this.frontdeskForm.controls.frontdeskList[
        "controls"
      ][index]["controls"]["lastName"].value
        .charAt(0)
        .toUpperCase();
      const firstNameletter = this.frontdeskForm.controls.frontdeskList[
        "controls"
      ][index]["controls"]["firstName"].value
        .charAt(0)
        .toUpperCase();
      this.frontdeskForm.controls.frontdeskList["controls"][index]["controls"][
        "initial"
      ].setValue(firstNameletter + lastNameletter);
    }
  }

  deletefrontdesk(index, techid) {
    const frontdeskId = techid;
    this.appservice.deleteFrontDesk(frontdeskId).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] == 200) {
          if (this.type == "w") {
            this.workingEmpolyee.splice(index, 1);
          } else if (this.type == "t") {
            this.terminateEmpolyee.splice(index, 1);
          }
          this.backendmessage = this.techmessage.deleteSuccess;

          setTimeout(() => {
            this.backendmessage = "";
          }, 5000);
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getStateList(index, countryid) {
    this.statedisable = true;
    this.appservice.getState(countryid).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.frontdeskForm.controls.frontdeskList["controls"][index][
            "controls"
          ]["stateList"].setValue(res["entity"]);
        }
        this.statedisable = false;
      },
      (err) => {
        this.statedisable = false;
        this.appservice.sessionOut(err);
      }
    );
  }

  getcountry() {
    return this.frontDeskSharedService.getcountry(this);
  }
}
